<template lang="pug">
    .address-field(v-if="edit")
        el-form-item(:label="$t(config.name)" :prop="validationPath" :size="size")
            el-autocomplete.is-full-width(
                v-model="query"
                :trigger-on-focus="true"
                :hide-loading="false"
                :popper-append-to-body="true"
                :debounce="300"
                :fetch-suggestions="findAddresses"
                autocomplete="no-fill"
                @select="selectAddress"
                @blur="cleanupAddress"
            )
</template>

<script>
import axios from 'axios'
import uniqid from 'uniqid'
import { getTime, startOfDay } from 'date-fns'
import _ from 'lodash'
import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import { country } from '@/filters'
import store from '@/store'

import Field from './Field'

export default {
    name: 'AddressField',
    extends: Field,
    data() {
        return {
            proximity: [10.4515, 51.1657], // default: germany
            query: '',
        }
    },
    computed: {
        address() {
            return _.get(this.content, 'addresses.0')
        }
    },
    methods: {
        generateOneliner() {
            const language = 'de'

            let parts = []
            if (this.address) {
                if (this.address.street) parts.push(this.address.street)
                if (this.address.zipcode || this.address.city)
                    parts.push(_.trim(`${this.address.zipcode} ${this.address.city}`))
                if (this.address.country) parts.push(country(this.address.country, language))
            }

            return parts.join(', ')
        },
        cleanupAddress() {
            if (this.address && this.query !== this.generateOneliner()) {
                // let address = _.cloneDeep(this.address)
                // address.deleted = true
                this.query = ''

                this.$set(this.content, 'addresses', [])
            }
        },
        selectAddress(address) {
            let zipcode, city, street, country, latitude, longitude

            if (address.data && address.data.context && address.data.context.length) {
                if (address.data.id.startsWith('address')) {
                    // find street
                    if (address.data.address) street = _.trim(`${address.data.text} ${address.data.address}`)
                    else street = address.data.text
                } else if (address.data.id.startsWith('postcode')) {
                    // find zipcode
                    zipcode = address.data.text
                }

                address.data.context.forEach(entry => {
                    if (entry.id.startsWith('postcode')) {
                        // find zipcode
                        zipcode = entry.text
                    } else if (entry.id.startsWith('place')) {
                        // find city
                        city = entry.text
                    } else if (entry.id.startsWith('country')) {
                        // find country
                        country = countries.getAlpha2Code(entry.text, 'de')
                    }
                })

                longitude = address.data.center[0]
                latitude = address.data.center[1]
            }

            if (this.content && this.config.key) {
                let address = { zipcode, city, street, country, latitude, longitude }
                if (this.address && this.address.id) address.id = this.address.id
                else address.id = uniqid('new:')

                // const payload = {
                //     i: this.i,
                //     s: this.s,
                //     c: this.c,
                //     address,
                // }

                // store.commit(`${this.module}/form/addressFieldValue`, payload)

                let a;
                const addresses = _.get(this.content, 'addresses');
                if (addresses === undefined) {
                    this.$set(this.content, 'addresses', []);
                    a = 0;
                } else if (address.id) {
                    a = _.findIndex(addresses, { id: address.id });
                    if (a < 0) a = addresses.length;
                }

                if (a >= 0) {
                    this.$set(this.content.addresses, a, address);
                }
            }
        },
        findAddresses(query, cb) {
            if (! query) return cb([])

            const language = 'de'
            const timestamp = getTime(startOfDay(new Date()))
            const proximity = this.proximity.join(',')

            let url = `${process.env.VUE_APP_MAPBOX_GOECODING_ENDPOINT}${query}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}`;
            url += `&cachebuster=${timestamp}`;
            url += `&autocomplete=true`;
            url += `&language=${language}`;
            url += `&types=postcode,address`;
            url += `&proximity=${proximity}`;

            axios
                .get(url)
                .then(({ data }) => {
                    let suggestions = []
                    if (data && data.features && data.features.length) {
                        data.features.forEach(feature => {
                            if (feature.place_name
                                // && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                && feature.relevance >= 0.5
                            ) {
                                suggestions.push({ value: feature.place_name, data: feature })
                            }
                        })
                    }

                    cb(suggestions)
                })
                // eslint-disable-next-line
                .catch(err => cb(null));

        },
    },
    mounted() {
        if (this.address) {
            const oneLiner = this.generateOneliner()
            this.query = oneLiner
        }

        navigator.geolocation.getCurrentPosition(
            position => {
                this.proximity = [position.coords.longitude, position.coords.latitude]
            },
            // eslint-disable-next-line
            error => console.error(error)
        );
    }
}
</script>
